import { useState, useEffect } from "react";

const alerts = [
  { id: 1, level: "high", icon: "ri-alarm-warning-line", color: "text-red-500", bg: "bg-red-50", border: "border-red-200", title: "管道压力异常", desc: "朝阳区建国路调压站出口压力降至0.12MPa，低于安全阈值，建议立即检查", time: "2分钟前", action: "立即处理" },
  { id: 2, level: "high", icon: "ri-fire-line", color: "text-orange-500", bg: "bg-orange-50", border: "border-orange-200", title: "用气量突增告警", desc: "GAS-2024-007 用户本小时用气量较均值高出420%，疑似泄漏，已自动触发告警", time: "8分钟前", action: "派员检查" },
  { id: 3, level: "medium", icon: "ri-battery-low-line", color: "text-amber-500", bg: "bg-amber-50", border: "border-amber-200", title: "设备电量预警", desc: "4台IoT表具电池电量低于15%，预计72小时内断电，建议安排更换", time: "15分钟前", action: "安排维护" },
  { id: 4, level: "medium", icon: "ri-money-cny-circle-line", color: "text-teal-500", bg: "bg-teal-50", border: "border-teal-200", title: "欠费风险预警", desc: "AI识别到23户用户欠费风险升高，建议今日完成短信催缴推送", time: "32分钟前", action: "批量催缴" },
];

const todos = [
  { id: 1, icon: "ri-shield-check-line", color: "text-orange-500", bg: "bg-orange-50", title: "安检任务", desc: "今日待安检 12户", urgent: true, path: "/safety" },
  { id: 2, icon: "ri-tools-line", color: "text-teal-500", bg: "bg-teal-50", title: "报装审核", desc: "待审核申请 5件", urgent: false, path: "/install" },
  { id: 3, icon: "ri-message-2-line", color: "text-amber-500", bg: "bg-amber-50", title: "短信催缴", desc: "待发送 156条", urgent: false, path: "/sms" },
  { id: 4, icon: "ri-bank-line", color: "text-green-500", bg: "bg-green-50", title: "银行代扣", desc: "今日代扣 89笔", urgent: false, path: "/bank" },
];

export default function AIAlertPanel() {
  const [activeAlert, setActiveAlert] = useState(0);
  const [dismissed, setDismissed] = useState<number[]>([]);

  useEffect(() => {
    const t = setInterval(() => {
      setActiveAlert(a => (a + 1) % alerts.length);
    }, 4000);
    return () => clearInterval(t);
  }, []);

  const visibleAlerts = alerts.filter(a => !dismissed.includes(a.id));

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* AI Smart Alerts */}
      <div className="bg-white rounded-xl border border-gray-100 p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center rounded-lg bg-[#E8531A]/10">
              <i className="ri-brain-line text-[#E8531A] text-sm"></i>
            </div>
            <span className="text-sm font-semibold text-gray-800">AI 智能预警</span>
            {visibleAlerts.filter(a => a.level === "high").length > 0 && (
              <span className="text-xs bg-red-500 text-white px-1.5 py-0.5 rounded-full animate-pulse">
                {visibleAlerts.filter(a => a.level === "high").length}
              </span>
            )}
          </div>
          <span className="text-xs text-gray-400">实时监控中</span>
        </div>
        <div className="space-y-2">
          {visibleAlerts.slice(0, 3).map((alert, i) => (
            <div
              key={alert.id}
              className={`flex items-start gap-2.5 p-2.5 rounded-lg border transition-all ${i === activeAlert % visibleAlerts.length ? `${alert.bg} ${alert.border}` : "bg-gray-50 border-transparent"}`}
            >
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${alert.icon} ${alert.color} text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-gray-800">{alert.title}</span>
                  <span className="text-[10px] text-gray-400 flex-shrink-0 ml-2">{alert.time}</span>
                </div>
                <p className="text-xs text-gray-500 mt-0.5 leading-relaxed line-clamp-1">{alert.desc}</p>
              </div>
              <div className="flex gap-1 flex-shrink-0">
                <button className={`text-[10px] ${alert.color} border border-current/30 px-2 py-0.5 rounded cursor-pointer whitespace-nowrap hover:opacity-80`}>
                  {alert.action}
                </button>
                <button
                  onClick={() => setDismissed(d => [...d, alert.id])}
                  className="w-4 h-4 flex items-center justify-center text-gray-300 hover:text-gray-500 cursor-pointer"
                >
                  <i className="ri-close-line text-xs"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Today's Todos */}
      <div className="bg-white rounded-xl border border-gray-100 p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 flex items-center justify-center rounded-lg bg-teal-50">
              <i className="ri-task-line text-teal-600 text-sm"></i>
            </div>
            <span className="text-sm font-semibold text-gray-800">今日待办</span>
          </div>
          <span className="text-xs text-[#E8531A] font-medium">{todos.length}项任务</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {todos.map(todo => (
            <a key={todo.id} href={todo.path} className={`flex items-center gap-2.5 p-2.5 rounded-lg ${todo.bg} hover:opacity-80 transition-opacity cursor-pointer`}>
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white flex-shrink-0">
                <i className={`${todo.icon} ${todo.color} text-sm`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-1">
                  <span className="text-xs font-semibold text-gray-800">{todo.title}</span>
                  {todo.urgent && <span className="text-[9px] bg-red-500 text-white px-1 rounded">急</span>}
                </div>
                <p className="text-xs text-gray-500">{todo.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
